import { render, staticRenderFns } from "./ItemGol7m.vue?vue&type=template&id=1ed93e18&scoped=true&"
import script from "./ItemGol7m.vue?vue&type=script&lang=js&"
export * from "./ItemGol7m.vue?vue&type=script&lang=js&"
import style0 from "./ItemGol7m.vue?vue&type=style&index=0&id=1ed93e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed93e18",
  null
  
)

export default component.exports